export default __webpack_public_path__ + "static/media/IconDesc_SpitterPart.256.fa6b9448.png";